import List from '@pelckmans/elementis/components/list';
import ChapterIcon from '@pelckmans/elementis/icons/chapter';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModuleContext from '../../_contexts/ModuleContext';
import { SearchResultToc } from './../api/search-api';
import { useParams } from 'react-router-dom';
import { useRoutes } from '../../../../hooks/useRoutes';
import Pill from '@pelckmans/elementis/components/pill';
import Avatar from '@pelckmans/elementis/components/avatar';
import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import { buildGroupProps } from '../../../../utils/elementisUtils';
import useLicenses from '../../../../hooks/useLicenses';
import stripHtml from '../../../../utils/wordlist/stripHtml';

interface Props {
  searchItem: SearchResultToc;
}

function SearchResultTocItem({ searchItem }: Props) {
  const { allModules } = useContext(ModuleContext);
  const { t } = useTranslation();
  const { buildAbsolutePath } = useRoutes();
  const { subjectSlug, methodSlug, moduleSlug: superModuleSlug } = useParams();
  const { isModuleLicensed } = useLicenses();

  const targetModule = allModules.find(m => m.id === searchItem.moduleId);
  if (!targetModule) return null;

  const licensedModule = isModuleLicensed(targetModule);

  const medialinkModuleSlug = targetModule.slug || undefined;

  const nodeHref =
    subjectSlug && methodSlug && superModuleSlug && medialinkModuleSlug
      ? buildAbsolutePath(['MATERIAL', 'MATERIAL.CONTENT', 'MATERIAL.CONTENT.TOC'], {
          subjectSlug,
          methodSlug,
          moduleSlug: superModuleSlug,
          selectedModuleSlug: medialinkModuleSlug,
          nodeId: searchItem.id,
        })
      : undefined;
  const locationTitles = searchItem.pathTitles ? [...searchItem.pathTitles] : [];
  locationTitles.pop(); // remove own title

  return (
    <List.Item
      key={searchItem.id}
      as="link"
      href={nodeHref || ''}
      disabled={!licensedModule}
      pillGroupProps={buildGroupProps(
        <>
          <Pill key="scope-pill">{t('PAGES.SEARCH.RESULTS.TOC')}</Pill>
          <Pill
            key="module-pill"
            size="sm"
            avatar={
              <Avatar>
                <AvatarImage size="xs" name={targetModule.niceName} src={targetModule.styling?.logo || ''} />
              </Avatar>
            }
          >
            {targetModule.niceName}
          </Pill>
          {locationTitles.length > 0 && (
            <Pill key="hierarchy-pill" icon={<ChapterIcon />}>
              {locationTitles.join(': ')}
            </Pill>
          )}
        </>,
      )}
      title={!licensedModule ? stripHtml(searchItem.name) : searchItem.name}
    />
  );
}

export default SearchResultTocItem;
